import React from 'react';

const SearchBar = ({
  searchTerm,
  setSearchTerm,
  searchType,
  setSearchType,
  timezone,
  setTimezone,
}) => {
  const handleSearchTypeChange = (e) => {
    setSearchType(e.target.value);
    setSearchTerm('');
  };

  return (
    <div className="field-row" style={{ marginBottom: 0 }}>
      <input
        type="text"
        className="text-input grow"
        placeholder={
          searchType === 'date'
            ? 'Enter date (e.g. September 7, 2026)'
            : 'Search by username or email'
        }
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <select
        className="text-input"
        value={searchType}
        onChange={handleSearchTypeChange}
      >
        <option value="all">Search All</option>
        <option value="user">Search Users</option>
        <option value="action">Search Actions</option>
        <option value="date">Search by Date</option>
      </select>
      <select
        className="text-input"
        value={timezone}
        onChange={(e) => setTimezone(e.target.value)}
      >
        <option value="Asia/Kolkata">IST (Asia/Kolkata)</option>
        <option value="UTC">UTC</option>
        <option value="America/New_York">EST (America/New_York)</option>
        <option value="Europe/London">GMT (Europe/London)</option>
        <option value="Asia/Dubai">UAE (Asia/Dubai)</option>
        <option value="Asia/Riyadh">Saudi Arabia (Asia/Riyadh)</option>
        <option value="Australia/Sydney">Australia/Sydney</option>
      </select>
    </div>
  );
};

export default SearchBar;
